import {PostWithoutResponse, UpdateResource, PatchResource} from "../../api/SpineClient";
import {GetRestResource} from "../../api/RestResourceClient";
import tigerbox_grey from "../../../assets/images/tigerboxes/tigerbox_touch_grey.png";
import tigerbox_black from "../../../assets/images/tigerboxes/tigerbox_touch_black.png";
import tigerbox_purple from "../../../assets/images/tigerboxes/tigerbox_touch_purple.png";
import tigerbox_green from "../../../assets/images/tigerboxes/tigerbox_touch_green.png";
import tigerbox_red from "../../../assets/images/tigerboxes/tigerbox_touch_red.png";
import tigerbox_blue from "../../../assets/images/tigerboxes/tigerbox_touch_blue.png";
import tigerbox_darkblue from "../../../assets/images/tigerboxes/tigerbox_touch_dark_blue.png";
import tigerbox_lightblue from "../../../assets/images/tigerboxes/tigerbox_touch_light_blue.png";
import tigerbox_coral from "../../../assets/images/tigerboxes/tigerbox_touch_coral.png";
import tigerbox_yellow from "../../../assets/images/tigerboxes/tigerbox_touch_yellow.png";
import minibox_default from "../../../assets/images/tigerboxes/minibox_default.png";
import minibox_owl from "../../../assets/images/tigerboxes/minibox_owl.png";
import minibox_tiger from "../../../assets/images/tigerboxes/minibox_tiger.png";
import minibox_squirrel from "../../../assets/images/tigerboxes/minibox_squirrel.png";
import minibox_dragon from "../../../assets/images/tigerboxes/minibox_dragon.png";
import minibox_unicorn from "../../../assets/images/tigerboxes/minibox_unicorn.png";

//API METHODS

export async function GetDevicesForAccount(accountId) {
    return await GetRestResource('api/devices/search/by-account-id?accountId=' + accountId, false, false);
}

export async function ReleaseFromDevice(deviceId) {
    return await PostWithoutResponse('api/devices/' + deviceId + '/release');
}

export async function UpdateDeviceName(device, newName) {
    return await UpdateResource('api/devices/' + device.id, {...device, displayName: newName});
}

export async function UpdateDeviceCurrentProfile(deviceId, profileId) {
    return await PatchResource('api/devices/' + deviceId, {currentProfileId: profileId});
}

export function GetDeviceIcon(device) {
    if (!device) {
        return tigerbox_grey;
    }
    if (device.deviceType === "PREMIUMBOX") {
        if (device.color == null) {
            return tigerbox_grey;
        } else if (device.color === "BLACK") {
            return tigerbox_black;
        } else if (device.color === "PURPLE") {
            return tigerbox_purple;
        } else if (device.color === "GREEN") {
            return tigerbox_green;
        } else if (device.color === "RED") {
            return tigerbox_red;
        } else if (device.color === "BLUE") {
            return tigerbox_blue;
        } else if (device.color === "DARK_BLUE") {
            return tigerbox_darkblue;
        } else if (device.color === "LIGHT_BLUE") {
            return tigerbox_lightblue;
        } else if (device.color === "CORAL") {
            return tigerbox_coral;
        } else if (device.color === "YELLOW") {
            return tigerbox_yellow;
        } else {
            return tigerbox_grey;
        }
    } else if (device.deviceType === "MINIBOX") {
        if (device["_embedded"]["device-design"]) {
            var design = device["_embedded"]["device-design"];
            var designName = design.referenceName;
            if (designName === "OWL") {
                return minibox_owl;
            } else if (designName === "TIGER") {
                return minibox_tiger;
            } else if (designName === "SQUIRREL") {
                return minibox_squirrel;
            } else if (designName === "UNICORN") {
                return minibox_unicorn;
            } else if (designName === "DRAGON") {
                return minibox_dragon;
            } else {
                return minibox_default;
            }
        } else {
            return minibox_default;
        }
    }
}
